import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { resetPassword } from "../services/authServices";
import { useModal } from "../context/ModalContext";
import { useNavigate } from "react-router-dom";

function Setttings() {
  const navigate = useNavigate();

  return (
    <div className="container py-8 px-[5rem] bg-[#fbfbfb]">
      <Header title={"Settings"} date="Sunday, 22 Dec 2024" />
      <h2 className="text-lg font-semibold mb-4 text-[#585858]">
      </h2>
      <div className="flex space-x-4">
        {/* Manager's Settings */}
        <div
          className="bg-white rounded-lg border border-gray-300 shadow-sm p-6 content-center text-center h-[200px] w-[300px] cursor-pointer"
          onClick={() => navigate("/change-manager-password")}
        >
          <h3 className="text-2xl font-semibold text-blue-500">
            Manager's settings
          </h3>
        </div>

        {/* Validator's Settings /validators/list*/}
        <div
          className="bg-white rounded-lg border border-gray-300 shadow-sm p-6 content-center text-center h-[200px] w-[300px] cursor-pointer"
          onClick={() => navigate("/validators/settings")}
        >
          <h3 className="text-2xl font-semibold text-blue-500">
            Validator's Settings
          </h3>
        </div>
      </div>
    </div>
  );
}

export default Setttings;
